
import React, { useState, useEffect } from 'react'
import { FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem } from '@mui/material'

import './filterList.css'

import { useCatalog } from '../../../../hooks/useCatalog'

export const CatalogFilters = ({ filters, setFilters }) => {

    const { categorias, initLoadCategorias } = useCatalog()
    //const [anchorEl, setAnchorEl] = useState(null)
    // const [initialFilters, setInitialFilters] = useState(filters)
    const initialFilters = filters
    const [form, setForm] = useState(filters)

    // const handleClick = (event) => {
    //     setAnchorEl(event.currentTarget);
    // }

    // const handleClose = () => {
    //     setAnchorEl(null);
    // };

    const handleChangeChecked = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.checked
        });
    }

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        });
    }

    const handleClean = () => {
        setFilters(initialFilters)
        setForm(initialFilters)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setFilters(form)
    }

    useEffect(() => {
        initLoadCategorias()
    }, [initLoadCategorias])


    return (
        <div>
            <form onSubmit={handleSubmit} className="row g-2 formFilterList">

                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_activo}
                                onChange={handleChangeChecked}
                                name="check_activo"
                                color='secondary'
                            />
                        }
                        label="Habilitados"
                    />
                </div>

                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_desactivo}
                                onChange={handleChangeChecked}
                                name="check_desactivo"
                                color='secondary'
                            />
                        }
                        label="Desactivados"
                    />
                </div>

                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_venta}
                                onChange={handleChangeChecked}
                                name="check_venta"
                                color='secondary'
                            />
                        }
                        label="Venta"
                    />
                </div>

                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_compra}
                                onChange={handleChangeChecked}
                                name="check_compra"
                                color="secondary"
                            />
                        }
                        label="Compra"
                    />
                </div>

                <div className="col-12 selectSpan">
                    <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">Categoría (*)</InputLabel>
                        <Select
                            label="Categoría (*)"
                            id="id_categoria"
                            name="id_categoria"
                            value={form?.id_categoria || ''}
                            onChange={handleChange}
                            className='p-list-capitalize'
                        >
                            <MenuItem value='' key=''>Ninguno</MenuItem>
                            {categorias.map(item => (
                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>
                                    {item.nombre}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>

                <div className="col-12 formFilterListButtons">
                    <button
                        type="button" className="btn btn-light buttonLimpiarFiltro"
                        onClick={handleClean}
                    >
                        Limpiar filtros
                    </button>
                    <button
                        type="button" className="btn btn-primary buttonBuscar"
                        onClick={handleSubmit}>
                        Buscar
                    </button>
                </div>

            </form>
        </div>
    )
}
